const Status= {
    ENABLED: "ENABLED",
    DISABLED: "DISABLED"
}
export default Status;